import './index.less';
import * as React from 'react';
import classNames from 'classnames';
import { Timeline, Tag, Icon, Row, Col } from '@beehive/components';
import moment from 'moment';
import { intervalHumanizer } from 'utils/date';
import { MessageBox } from 'components';
import { isBlank } from 'utils/object';
import { getLocaleAttr } from 'utils/locales';
import PropTypes from 'prop-types';
import commonMsg from 'messages';
import journalTimeLineMsg from 'messages/Components/JournalTimeLine';
import { $sType } from '@mpc/common/src/utils/sType';

const messages = { ...commonMsg, ...journalTimeLineMsg };

interface JournalTimeLineProps {
  prefixCls?: string;
  className?: string;
  journals: any[];
}

class JournalTimeLine extends React.Component<JournalTimeLineProps, any> {
  public static contextTypes = {
    intl: PropTypes.object,
  };

  public getJournalDetail = (detail: any) => {
    const { intl } = this.context;
    switch (detail.change_type) {
      case 'journal_changed_no_detail':
        return intl.formatMessage(messages.updated);
      case 'journal_changed':
        return (
          <React.Fragment>
            {intl.formatMessage(messages.from)}
            <span className="change-value">{detail.old_value}</span>
            {intl.formatMessage(messages.to)}
            <span className="change-value">{detail.value}</span>
          </React.Fragment>
        );
      case 'journal_set_to':
        return (
          <React.Fragment>
            {intl.formatMessage(messages.setTo)}
            <span className="change-value">{Array.isArray(detail.value) ? detail.value.join(',') : detail.value}</span>
          </React.Fragment>
        );
      case 'journal_deleted':
        return (
          <React.Fragment>
            <span className="change-value">{detail.old_value}</span>
            {intl.formatMessage(messages.deleted)}
          </React.Fragment>
        );
      case 'journal_add':
        return (
          <React.Fragment>
            <span className="change-value">{detail.value}</span>
            {intl.formatMessage(messages.added)}
          </React.Fragment>
        );
      case 'journal_added':
        if (detail.property === 'attachment') {
          return (
            <React.Fragment>
              <Icon name="paperclip" />
              <a href={`/api/v1/attachments/${detail.field_id}?download=attachment`} download>
                {detail.value}
              </a>
            </React.Fragment>
          );
        }
    }
    return null;
  };
  public messageHeaderRender = (journal: any) => {
    const { intl } = this.context;
    const time = intervalHumanizer(journal.interval);

    return (
      <React.Fragment>
        <span className="">{journal.state}</span>
        {!isBlank(journal.interval) && (
          <span className="pull-right text-color-secondary font-size-sm">
            {intl.formatMessage(messages.cost)}
            {` ${time.val} `}
            {intl.formatMessage(messages[`timingUnit.${time.unit}`], { num: time.val })}
          </span>
        )}
      </React.Fragment>
    );
  };

  public messageContentRender = (journal: any) => {
    const { intl } = this.context;
    const labelSpan = getLocaleAttr(intl.locale).journalLabelSpan;
    return (
      <React.Fragment>
        <div className="journal-time-line-detail">
          <Icon name="user-o" />
          {journal.operator}
        </div>
        {journal.details &&
          journal.details.map((item: any, idx: number) => {
            return (
              <Row className="journal-time-line-detail" key={idx}>
                <Col span={labelSpan} className="change-label">{`${item.field}：`}</Col>
                <Col span={24 - labelSpan} className="change-content">
                  {this.getJournalDetail(item)}
                </Col>
              </Row>
            );
          })}
        {/* todo：node备注在外包不可见，只在内包可见，后面迁移的时候要注意 */}
        {!!journal.note && $sType !== 'outer' && (
          <div className="journal-time-line-detail">
            <div className="change-note">{journal.note}</div>
          </div>
        )}
      </React.Fragment>
    );
  };

  public beforeRender = (journal: any, index: number) => {
    const { intl } = this.context;
    const dateMoment = moment(journal.created_at);
    return (
      <div className="journal-timeline-before-item">
        <div className="">
          {index === 0 && <Tag text={intl.formatMessage(messages.lasest)} />}
          <span className="journal-date font-bold">{dateMoment.format('YYYY-MM-DD')}</span>
        </div>
        <div className="text-color-secondary font-size-sm">{dateMoment.format('HH:mm')}</div>
      </div>
    );
  };

  public afterRender = (journal: any, index: number) => {
    return (
      <MessageBox
        header={this.messageHeaderRender(journal)}
        content={this.messageContentRender(journal)}
        type="right"
      />
    );
  };

  public render() {
    const { prefixCls = 'mpc', className, journals } = this.props;
    const classes = classNames(className, {
      [`${prefixCls}-journal-timeline`]: true,
    });
    return (
      <Timeline type="both" className={classes} beforeSpan={8}>
        {journals.map((jounral: any, idx: number) => {
          return (
            <Timeline.Item key={idx} before={this.beforeRender(jounral, idx)} after={this.afterRender(jounral, idx)} />
          );
        })}
      </Timeline>
    );
  }
}

export default JournalTimeLine;
